export const INTER_FALLBACK_FONT = 'Inter-Fallback';

// Shared tail of every theme font stack: Inter, then a local metric-adjusted
// stand-in for Inter's swap window, then the generic family.
export const THEME_FONT_FALLBACK_STACK = `'Inter', '${INTER_FALLBACK_FONT}', sans-serif`;

// The union of the subsets Google serves for Inter: latin, latin-ext, cyrillic,
// cyrillic-ext, greek, greek-ext and vietnamese. Scoping the fallback face to
// exactly Inter's own coverage keeps Latin-calibrated metrics off the scripts
// Inter never ships — Hebrew (U+0590–05FF) and Arabic (U+0600–06FF) among them —
// so RTL text keeps the platform font at its natural metrics.
const INTER_COVERAGE_UNICODE_RANGE = [
  'U+0000-052F',
  'U+1C80-1C8A',
  'U+1D00-1DBF',
  'U+1E00-1EFF',
  'U+1F00-1FFF',
  'U+2000-20C0',
  'U+2113',
  'U+2116',
  'U+2122',
  'U+2191',
  'U+2193',
  'U+2212',
  'U+2215',
  'U+2C60-2C7F',
  'U+2DE0-2DFF',
  'U+A640-A69F',
  'U+A720-A7FF',
  'U+FE2E-FE2F',
  'U+FEFF',
  'U+FFFD',
].join(', ');

// Wraps local Arial/Helvetica Neue with Inter's typographic metrics so text
// rendered during Inter's download window occupies the same space — when Inter
// arrives, the swap causes no visible reflow (FOUT). Override values are
// calibrated to Inter v20 (the version served by Google Fonts); recalibrate if
// the served Inter version changes.
export const INTER_FALLBACK_FONT_FACE = `
    @font-face {
      font-family: '${INTER_FALLBACK_FONT}';
      src: local('Arial'), local('Helvetica Neue');
      ascent-override: 90.20%;
      descent-override: 22.48%;
      line-gap-override: 0%;
      size-adjust: 107.40%;
      unicode-range: ${INTER_COVERAGE_UNICODE_RANGE};
    }`;
